module.exports = __webpack_public_path__ + "img/gh36060-2.prt.6eca9cef.jpg";